import { render, staticRenderFns } from "./BrothersAndSistersDetail.vue?vue&type=template&id=260804ab&scoped=true&"
import script from "./BrothersAndSistersDetail.vue?vue&type=script&lang=js&"
export * from "./BrothersAndSistersDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrothersAndSistersDetail.vue?vue&type=style&index=0&id=260804ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260804ab",
  null
  
)

export default component.exports